import module from 'fan/proyecto/module.js'
import template from './template.html'

function Modelo () {
  this.colaborador_id = null
  this.colaborador = ''
  this.fecha = null
  this.notas = ''
  this.completado = false
  this.actualizado = false
  this.error = null
}

export class FanProyectoColaboradoresEditarAltasComponent {
  constructor ($state) {
    this.$state = $state
    this.actualizando = false
    this.completado = false
    this.data = null
    this.error = null
    this.step = 1
    this.idProyecto = undefined
    this.resultados = undefined
    this.modelo = Modelo
  }

  $onInit () {
    this.headers = [{
      id: 'colaborador_id',
      name: 'Colaborador ID',
      group: 'REQUERIDO',
      parser: (value) => (Number(value) || 0),
      processor: (object, value) => {
        object.colaborador_id = value

        return object
      },
      match: (value) => ['COLABORADOR_ID', 'EMPLEADO_ID', 'NOMBRE_ID'].indexOf(value.toUpperCase()) >= 0,
    }, {
      id: 'colaborador',
      name: 'Colaborador',
      group: 'REQUERIDO',
      parser: (value) => value.trim(),
      processor: (object, value) => {
        object.colaborador = value

        return object
      },
      match: (value) => ['COLABORADOR', 'EMPLEADO', 'NOMBRE'].indexOf(value.toUpperCase()) >= 0,
    }, {
      id: 'clase',
      name: 'Clase prima riesgo',
      group: 'SUELDOS Y SALARIOS',
      parser: (value) => value.trim(),
      processor: (object, value) => {
        object.clase = value

        return object
      },
      match: (value) => ['CLASE', 'REGISTRO PATRONAL'].indexOf(value.toUpperCase()) >= 0,
    },
      {
        id: 'fecha_movimiento',
        name: 'Fecha de movimiento',
        group: 'REQUERIDO',
        parser: (value) => value.trim(),
        processor: (object, value) => {
          object.fecha_movimiento = value

          return object
        },
        match: (value) => ['FECHA MOVIMIENTO', 'FECHA_MOVIMIENTO'].indexOf(value.toUpperCase()) >= 0,
      }]
  }

  actualizar (data) {
    if (!data) return
    this.resultados = data
    this.resultados.map((item, indice) => item.indice = indice + 1)
    this.step = 3
  }

  iniciar () {
    this.resultadosModal = this.resultados.filter((item) => !item.actualizado)
    this.completado = true
  }

  terminar (event) {
    this.completado = false

    if (event) {
      let error = event.some((item) => item.error)
      if (!error) this.$state.go('proyecto.colaboradores.lista')
      this.resultados.map((item) => {
        event.forEach((data) => {
          if (item.indice === data.indice) {
            item.error = data.error
            item.actualizado = data.actualizado
            item.completado = data.completado
          }
        })
      })
    }
  }

  importar (event) {
    this.data = null
    this.error = null
    this.alertas = []

    if (!event || !event.headers || !event.data) return

    if (event.headers.indexOf('colaborador') < 0 && event.headers.indexOf('colaborador_id') < 0) {
      return this.error = 'Especifique la columna "Colaborador" o "Colaborador ID"'
    }

    if (event.headers.indexOf('fecha_movimiento') < 0 && event.headers.indexOf('fecha_movimiento') < 0) {
      return this.error = 'Especifique la columna "Fecha de movimiento"'
    }

    this.data = event.data.filter((item, index) => {

      if (!this.verificarFecha(item.fecha_movimiento)) {
        this.alertas.push(`Se omitirá la fila #${index + 1} pues no tiene el formato correcto de fecha. Ej. (12/12/2020)`)
        return false
      }

      return true
    })
  }

  verificarFecha (fecha_movimiento) {
    let fecha = fecha_movimiento.split('/')

    if (fecha[0] > 0 && fecha[0] <= 31 && fecha[1] > 0 && fecha[1] < 13 && fecha[2].length === 4) return true
    else return false
  }

  validar () {
    this.alertas = []
    if (this.step === 2) return

    this.step = 2
  }
}

module.component('fanProyectoColaboradoresEditarAltas', {
  controller: FanProyectoColaboradoresEditarAltasComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/altas/component.js